import {configureStore} from '@reduxjs/toolkit'
import authSlice from './reducers/authSlice';
import eventSlice from './reducers/eventSlice';
import profileSlice from './reducers/profileSlice';
const store=configureStore({
    reducer:{
       event:eventSlice,
       auth:authSlice,
       profile:profileSlice,
    }
})


export default store;